import NativeScrollbar from './native-scrollbar';

const selectors = {
  siblingsInnerHolder: '[data-sibling-inner]',
};

class Siblings {
  constructor(holder) {
    this.siblings = holder.querySelectorAll(selectors.siblingsInnerHolder);

    this.init();
  }

  init() {
    this.siblings.forEach((sibling) => {
      new NativeScrollbar(sibling);
    });
  }
}

const siblings = {
  onLoad() {
    new Siblings(this.container);
  },
};

export {siblings, Siblings};
